var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"image_source":_vm.image_source,"image_height":_vm.image_height}},[(_vm.isGroup)?_c('a-hotel-selector-rms',{ref:"a-hotel-selector-rms"}):_c('pricing-strategy-app',{ref:"pricing-strategy-app"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }